import { axios } from '@/main';

export default class NotificationResource {
    async getNumber() {
        return await axios.get(process.env.VUE_APP_REST_API + 'system-messages/get-number')
    }

    async getWarning() {
        return await axios.get(process.env.VUE_APP_REST_API + 'system-messages/warnings')
    }

    async getUnread() {
        return await axios.get(process.env.VUE_APP_REST_API + 'system-messages/notifications/unread')
    }

    async read() {
        return await axios.get(process.env.VUE_APP_REST_API + 'system-messages/notifications/read')
    }
}
